import { ICSchedulation } from "./icschedulation";
import { ICTypeArea } from "./ictypearea";
import { Translation } from "./translation";

export class ICAreaType {
  Code: string;
  DeleteDate: string;
  Id: number;
  IdGuid: string;
  InsertDate: string;
  LastEditDate: string;
  Level: number;
  Name: Translation[];
  Primary: boolean;
  Schedulations: ICSchedulation[];
  TypeAreas: ICTypeArea[];

  constructor(data?: Partial<ICAreaType>) {
    Object.assign(this, data);
  }
}
